module.exports = __webpack_public_path__ + "img/1 (77).36fb312e.png";